/**
 * Created by RKL on 13/08/2015.
 */
define('mbAModelDetailTabController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'mbAModelDetailView',
  'settings'
], function(
  module,
  _,
  Backbone,
  App,
  View
) {
  'use strict';

  var MbAModelDetailTabController = {
    showTab: function(data) {
      if (!data.tab) {
        data.tab = 'detail';
      }
      this.showMbAModelInfo(data);
    },

    showMbAModelInfo: function(data) {
      var that = this;
      this.model = data.model;
      this.tab = data.tab;
      this.data = data;
      that.createView();
    },

    createView: function() {
      var view;
      view = new View({
        model: this.model
      });
      view.tempModel = new Backbone.Model(this.model.toJSON());
      this.view = view;

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('mbAModelDetailTab').show(view);
    }
  };

  module.exports = MbAModelDetailTabController;
});
